import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { formatUnits } from 'ethers';

import { showModalAction } from '@/shared/store/modals/actions';
import { ModalName } from '@/shared/store/modals/constants';

export const useWithdrawHandler = (
    assetName: string,
    balance: number,
    address: string,
    decimals: number,
) => {
    const dispatch = useDispatch();

    return useCallback(() => {
        dispatch(
            showModalAction({
                modalName: ModalName.FUND_CLAIM_MODAL,
                modalTitle: 'Withdraw Recovered Balance',
                modalProps: {
                    assetName,
                    balance: formatUnits(balance.toString(), decimals),
                    address,
                    decimals,
                },
            }),
        );
    }, [dispatch, assetName, balance, address, decimals]);
};
